<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="6" sm="8">
          <b-card no-body class="mx-4">
            <b-card-body class="p-4">
              <b-form @submit.prevent="onSubmit">
                <h1>Registro</h1>
                <div class="card-header-actions">
                    <b-button style="margin-bottom: 10px;" @click="$router.go(-1)" variant="primary">
                        <i class="icon-action-undo"></i> Regresar
                    </b-button>
                </div>
                <p class="text-muted">Crea tu Cuenta</p>
                <b-form-group label-for="nombre-usuario">
                    <b-input-group class="mb-3">
                        <b-input-group-prepend>
                            <b-input-group-text class="border-visible"><i class="icon-user"></i></b-input-group-text>
                        </b-input-group-prepend>
                        <b-form-input 
                            id="nombre-usuario"
                            data-vv-as="Nombre"
                            name="nombre-usuario"
                            type="text" 
                            class="form-control"
                            placeholder="Nombre"
                            autocomplete="nombre-usuario"
                            v-validate="'required|min:2'"
                            v-model="form.nombreUsuario"
                            :state="this.validateState('nombre-usuario')"
                            aria-describedby="input-1-live-feedback"
                            trim
                            />
                    </b-input-group>
                    <b-form-invalid-feedback  :state="this.validateState('nombre-usuario')">
                        <span v-for="error in errors.collect('nombre-usuario')" :key="error">{{ error }}</span>
                    </b-form-invalid-feedback>
                </b-form-group>

                <b-form-group label-for="clave-lic">
                    <b-input-group class="mb-3">
                        <b-input-group-prepend>
                            <b-input-group-text class="border-visible"><i class="icon-key"></i></b-input-group-text>
                        </b-input-group-prepend>
                        <b-form-input 
                            id="clave-lic"
                            data-vv-as="Clave"
                            name="clave-lic"
                            type="text"
                            class="form-control"
                            placeholder="Clave del Producto"
                            v-validate="{required: true, regex:/^[0-9A-F]{0,32}$/}"
                            v-model="form.licencia"
                            :state="this.validateState('clave-lic')"
                            />
                    </b-input-group>
                    <b-form-invalid-feedback  :state="this.validateState('clave-lic')">
                        <span v-for="error in errors.collect('clave-lic')" :key="error">{{ error }}</span>
                    </b-form-invalid-feedback>
                </b-form-group>

                <b-form-group label-for="email-usuario">
                    <b-input-group class="mb-3">
                        <b-input-group-prepend>
                            <b-input-group-text class="border-visible">@</b-input-group-text>
                        </b-input-group-prepend>
                        <b-form-input 
                            id="email-usuario"
                            name="email-usuario"
                            type="email"
                            class="form-control" 
                            placeholder="Correo Electrónico" 
                            data-vv-as="Correo electrónico"
                            autocomplete="email"
                            v-validate="'required|email'"
                            v-model="form.email"
                            :state="this.validateState('email-usuario')"
                         />
                    </b-input-group>
                    <b-form-invalid-feedback :state="this.validateState('email-usuario')">
                        <span v-for="error in errors.collect('email-usuario')" :key="error">{{ error }}</span>
                    </b-form-invalid-feedback>
                </b-form-group>

                <b-form-group label-for="contraseña-usuario">
                    <b-input-group class="mb-3">
                        <b-input-group-prepend>
                            <b-input-group-text class="border-visible"><i class="icon-lock"></i></b-input-group-text>
                        </b-input-group-prepend>
                        <b-form-input
                            id="contraseña-usuario"
                            name="contraseña-usuario"
                            type="password" 
                            class="form-control" 
                            placeholder="Contraseña"
                            data-vv-as="Contraseña"
                            autocomplete="new-password"
                            v-validate="'required|min:6'"
                            v-model="form.password"
                            :state="this.validateState('contraseña-usuario')"
                            ref="password"
                        />
                    </b-input-group>
                     <b-form-invalid-feedback  :state="this.validateState('contraseña-usuario')">
                        <span v-for="error in errors.collect('contraseña-usuario')" :key="error">{{ error }}</span>
                    </b-form-invalid-feedback>
                </b-form-group>

                <b-form-group label-for="confirmacion-usuario">
                    <b-input-group class="mb-4">
                    <b-input-group-prepend>
                        <b-input-group-text class="border-visible"><i class="icon-lock"></i></b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input 
                        id="confirmacion-usuario"
                        name="confirmacion-usuario"
                        data-vv-as="Confirmación de Contraseña"
                        v-validate="'required|confirmed:password'"
                        type="password"
                        class="form-control" 
                        placeholder="Confirmar Contraseña"
                        :state="this.validateState('confirmacion-usuario')"
                        v-model="form.confirm"
                         />
                    </b-input-group>
                     <b-form-invalid-feedback :state="this.validateState('confirmacion-usuario')">
                        <span v-for="error in errors.collect('confirmacion-usuario')" :key="error">{{ error }}</span>
                    </b-form-invalid-feedback>
                </b-form-group>

                <b-button type="submit" class="primary-btn-log" block :disabled="errors.any()">Crear cuenta</b-button>
              </b-form>
            </b-card-body>
            <!--<b-card-footer class="p-4">
              <b-row>
                <b-col cols="6">
                  <b-button block class="btn btn-facebook"><span>Facebook</span></b-button>
                </b-col>
                <b-col cols="6">
                  <b-button block class="btn btn-twitter" type="button"><span>Twitter</span></b-button>
                </b-col>
              </b-row>
            </b-card-footer>-->
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { UserService, AuthenticationError } from "../../services/user.service";
import { error } from 'util';
export default {
  name: 'Register',
  data() {
    return {
      form: {},
      licencia:''
    }
  },
  methods: {
    onSubmit() {
        this.$validator.validateAll().then((res) => {
          console.log(res);
          if(res) {
            UserService.SingIn(this.form).then(response => {
                response = response.data;
                return UserService.login(response.success.email,this.form.password);
            }).then(response => {
                this.$router.go('/dashboard');
            }).catch(error => {
              if(error.response.status == 500) {
                this.$swal({
                  type: "warning",
                  title: "¡Usuario no Creado!",
                  text: "El Usuario Ingresado ya ha Sido Creado",
                  showConfirmButton: false,
                  timer: 3000
                });
              }else if (error.response.status == 404) {
                this.$swal({
                  type: "error",
                  title: "¡Error!",
                  text: "Ocurrió un Error en la Base de Datos",
                  showConfirmButton: false,
                  timer: 3000
                });
              }
            });
          } else {
            this.$swal({
              type: "warning",
              title: "¡Campos Obligatorios!",
              text: "Completa los Campos Obligatorios",
              showConfirmButton: false,
              timer: 3000
            });
          }
        }).catch(err => console.log(err));
    },
    validateState(ref) {
      if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
        return !this.errors.has(ref)
      }
      return null
    },
    //verifica que licencia
    checkFilled () {
      console.log("verificando el tamaño")
      if (this.Register(this.formatClave(this.licencia)) === false) {
        console.log(this.licencia)
        return true
      }
      return false
    },
    //remueve los valores fuera de hexadecimal
    formatClave (clave) {
      var re = /^[0-9A-F]{0,32}$/;
      return re.test(email);
    },
    isDisabled (object){
      console.log(object.target.value)
      if (this.checkFilled() === true) {
        console.log("entro en isDisabled")
        document.getElementById("email-usuario").removeAttribute('disabled');
        return
        /*document.getElementById('email-usuario').removeAttribute('disabled');
        document.getElementById('contraseña-usuario').removeAttribute('disabled');
        document.getElementById('confirmacion-usuario').removeAttribute('disabled');
      } else {
        document.getElementById('email-usuario').setAttribute('disabled', null);
        document.getElementById('contraseña-usuario').setAttribute('disabled', null);
        document.getElementById('confirmacion-usuario').setAttribute('disabled', null);*/
      }
      document.getElementById("email-usuario").setAttribute('disabled', null);
      if (object.keyCode === 32) {
        object.preventDefault()
      }
      return
    }
  }
}
</script>
<style scoped>
.primary-btn-log {
  background-color: #b38e5d !important;
  border-color: #b38e5d !important;
  color: #ffffff;
}
</style>